export enum ICON_TYPE {
  CALENDAR = 'CALENDAR',
  FILTER = 'FILTER',
  SORTING = 'SORTING',
  BROWSE = 'BROWSE',
  ARROW_EXPAND_DOWN = 'ARROW_EXPAND_DOWN'
}
